export default "__VITE_ASSET__ivcSvBit__"